module.exports = __webpack_public_path__ + "img/icon_livechat_send.337c6fe7.svg";